import Layout from 'components/Layout'
import { GetStaticPaths } from 'next'
import { getBestListProps } from 'props-getters/bestList'
import PageContainer from 'shared-components/service/PageContainer'
import { ExtractGetterProps } from 'shared-definitions/util-types'
import BestListRatingsTemplateSG from 'templates/BestListRatingsTemplateSG'

const BestListPage: React.VFC<ExtractGetterProps<typeof getBestListProps>> = ({
  preview,
  page,
  common,
  ts,
}) => (
  <PageContainer
    layoutProps={{}}
    layout={Layout}
    props={{
      page,
      common,
      ts,
      preview,
    }}
  >
    <BestListRatingsTemplateSG page={page} />
  </PageContainer>
)

// eslint-disable-next-line @typescript-eslint/require-await
export const getStaticPaths: GetStaticPaths = async () => ({
  paths: [],
  fallback: 'blocking',
})

export const getStaticProps = getBestListProps()

export default BestListPage
